module.exports = __webpack_public_path__ + "img/73beba7.jpg";